import React from 'react'
import {FacebookIcon, InstagramIcon, LinkedinIcon} from '../Shared/Images/image';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { toLower } from 'lodash';
const footer = (props)=>{
    return(
        <footer>
            <div className="foot-wrap">
                <div className="mx-width">                
                    <div className="row pt-5 pb-3">
                        <div className="col-lg-3  col-sm-6">
                            <h5 className="heading5 text-color2">Visit Us</h5>
                            <div className="footer-address">
                                <h6>Office Number 32, 3rd floor </h6>
                                <h6>Opposite Jamia Ashrafia </h6>
                                <h6>Ferozpur Road Lahore </h6>                                
                                <h6>+92-323-8882012</h6>
                                <div className="d-flex justify-content-between pb-3 align-items-center">
                                    <div>
                                        <ul className="list-unstyled footer-social-links">
                                            <li><a href={props.social_links.facebook_url}  target="_blank"><img src={FacebookIcon} alt="facebook" /></a></li>
                                            <li><a href={props.social_links.instagram_url} target="_blank"><img src={InstagramIcon} alt="instagram" /></a></li>
                                            <li><a href={props.social_links.twitter_url}   target="_blank"><img src={LinkedinIcon} alt="linkedin" /></a></li>
                                        </ul>
                                    </div>                                    
                                </div> 
                            </div>
                        </div>
                       
                        <div className="col-lg-5  col-sm-6">
                            <h5 className="heading5 text-color2">Countries</h5>
                            <ul className="list-unstyled footer-links row mb-0">                                    
                                {
                                    props.contries === undefined ? <li>Loading</li> : 
                                        props.contries.map(contary=>{
                                        return(
                                            <li className="col-sm-6" key={contary.name}><Link to={"/eligibility/" + toLower(contary.name) + "/step1"}>{contary.name}</Link></li>
                                        )
                                    })                                                 
                                }
                            </ul>
                        </div>
                        <div className="col-lg-2  col-sm-6">
                            <ul className="list-unstyled footer-links">
                                <li><h5 className="heading5 text-color2">Explore</h5></li>
                                <li><Link to="/aboutus">About Us</Link></li>
                                <li><Link to="/contactus">Contact Us</Link></li>
                            </ul>
                            <ul className="list-unstyled footer-links">                                
                                <li><Link to="/services/ielts" >Ielts</Link></li>
                                <li><Link to="/services/degreeattestation">Degree Attest</Link></li>
                                <li><Link to="/services/immigration">Immigration</Link></li> 
                            </ul>
                           
                        </div>
                        <div className="col-lg-2  col-sm-6">
                            <ul className="list-unstyled footer-links">
                                <li><h5 className="heading5 text-color2">Progress</h5></li>
                                <li><Link to="/progress">Track Progress</Link></li>
                                <li><Link to="/contactus">Report a Problem</Link></li> 
                            </ul>
                        </div>
                    </div>  
                </div>
            </div>
         </footer>
    )
}
const mapStateToProps = state => {   
    return {
       contries: state.contries,
       social_links : state.social_links
    }
};
const mapDispatchToProps = dispatch => {   
    return {
        onSetCountry: (name) => dispatch({type: 'SET_COUNTARY', name:name}),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(footer);